/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { MenuSalesChannelShop } from "../models/Menus";
import { ActiveRestaurantListItem } from "./ActiveRestaurantListItem";

const listWrapperStyle = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

type Props = {
  salesChannels: MenuSalesChannelShop[] | undefined;
};

export const RestaurantsPopoverContent = ({ salesChannels }: Props) => {
  return (
    <div css={listWrapperStyle}>
      {(salesChannels || []).map((salesChannel, i) => (
        <ActiveRestaurantListItem key={i} salesChannel={salesChannel} />
      ))}
    </div>
  );
};
